import axios from "axios";
import { getLang } from "../i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Informa o idioma ao backend (mensagens de erro e conteúdo do CMS em inglês).
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-Lang"] = getLang();
  return config;
});
